import { render, staticRenderFns } from "./myBanner3.vue?vue&type=template&id=54658f50&scoped=true"
import script from "./myBanner3.vue?vue&type=script&lang=js"
export * from "./myBanner3.vue?vue&type=script&lang=js"
import style0 from "./myBanner3.vue?vue&type=style&index=0&id=54658f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54658f50",
  null
  
)

export default component.exports